import { tv, type VariantProps } from "tailwind-variants";
import Root from "./button.svelte";

const buttonVariants = tv({
	base: "inline-flex items-center justify-center whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 !shadow-none",
	variants: {
		variant: {
			default: "bg-primary text-theme-black hover:bg-white-hover",
			accent: "bg-accent text-theme-white hover:bg-accent-hover",
			destructive: "bg-destructive text-destructive-foreground hover:bg-destructive-hover",
			outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground",
			secondary: "bg-secondary text-secondary-foreground border border-dark-gray hover:border-medium-gray",
			ghost: "hover:bg-blue-gray text-primary",
			link: "text-primary underline-offset-4 hover:underline",
		},
		size: {
			default: "px-6 py-3",
			lg: "px-6 py-4",
			icon: "h-9 w-9",
		},
		rounded: {
			default: "rounded-[8px]",
			full: "rounded-full",
		},
	},
	defaultVariants: {
		variant: "default",
		size: "default",
		rounded: "default",
	},
});

export type ButtonVariant = VariantProps<typeof buttonVariants>["variant"];
export type ButtonSize = VariantProps<typeof buttonVariants>["size"];
export type ButtonRounded = VariantProps<typeof buttonVariants>["rounded"];

export type ButtonProps = {
	variant?: ButtonVariant;
	size?: ButtonSize;
	rounded?: ButtonRounded;
	typographyVariant?: string;
	typographyWeight?: string;
	class?: string;
	onclick?: (event: MouseEvent) => void;
	onkeydown?: (event: KeyboardEvent) => void;
};

export {
	Root,
	type ButtonProps as Props,
	//
	Root as Button,
	buttonVariants,
};
